import { Factory } from 'fishery';
import { CaseLabel } from '@trukt/types/CaseLabel';

export const caseLabelFactory = Factory.define<CaseLabel>(({ sequence }) => ({
  id: sequence.toString(),
  label: `Vendor Payment Hold`,
  description: `Prevents vendor from exporting invoice and bills`,
  isDeprecated: false,
}));
